export type RGB = [number, number, number];

export const WCAG_AA_BODY = 4.5;

export function relativeLuminance([r, g, b]: RGB): number {
  const lin = (c: number) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
}

export function contrastRatio(a: RGB, b: RGB): number {
  const la = relativeLuminance(a);
  const lb = relativeLuminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}

export function toHex(rgb: RGB): string {
  return `#${rgb.map((c) => Math.round(c).toString(16).padStart(2, '0')).join('')}`;
}

/** Darkens `fg` toward black, keeping its hue, until it meets `min` contrast on `bg`. */
export function darkenToContrast(fg: RGB, bg: RGB, min = WCAG_AA_BODY): RGB {
  for (let f = 1; f > 0; f -= 0.02) {
    const candidate = fg.map((c) => c * f) as RGB;
    if (contrastRatio(candidate, bg) >= min) return candidate;
  }
  return [0, 0, 0];
}
